<!--  -->
<template>
  <div>
    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '82%' }"
      duration="0.18"
      :close-on-click-overlay="false"
    >
      <div class="title">
        <p>请选择课程</p>
        <van-icon
          name="cross"
          @click="onClose"
        />
      </div>
      <div class="content">
        <div class="content-box">
          <div class="mandatory">
            <div
              class="mandatory-box"
              v-for="(item, index) in mandatoryCourse"
              :key="index"
            >
              <SelectCourseCard
                :courseInfo="item"
                @skuInfo="skuInfo"
              />
            </div>
          </div>
          <div
            class="optional"
            v-for="(child, index) in optionCourse"
            :key="index"
          >
            <div class="group-name">
              <p>{{ child.groupInfo.name }}</p>
              <span>以下课程选择{{ showNum(child.groupInfo.selectProductNum) }}门</span>
            </div>
            <ul class="optional-course">
              <li
                :class="{
                  active: item.isSelect,
                  disbaled: (child.disbaled && !item.isSelect) || item.disaled,
                }"
                v-for="(item, idx) in child.productSkuList"
                :key="idx"
                @click="chooseCourse(item, index, idx)"
              >
                <p class="ellipsis">
                  {{ item.name }}
                </p>
                <img
                  :src="checkIcon"
                  alt=""
                />
                <span>{{ String(item.skuName) }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="foot">
        <div
          class="foot-box "
          @click="addShopCar"
        >
          加入购物车
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { getBigNum } from '@/utils/tools';
import checkIcon from '@/assets/img/components/courseDetail/checkIcon.png';
import { reqAddCart } from '@/api/courseDetail/shoppingCar/shoppingCar';
import SelectCourseCard from './selectCourseCard.vue';

export default {
  components: {
    SelectCourseCard,
  },
  data() {
    return {
      combinationId: this.$route.query.combinationId,
      checkIcon,
      mandatoryCourse: [], // 必须课程
      optionCourse: [], // 可选课程
      chooseNum: 2, // 可选择的数量
      selectCourse: [], // 选择的课程
      // disbaled: false,
      numList: [],
      show: true,
    };
  },
  props: {
    buyBtnData: {
      type: Object,
      default: () => { },
    },
  },
  computed: {
    ...mapState(['courseBaseData']),
  },
  mounted() {
    this.initData();
  },

  methods: {
    onClose() {
      this.$emit('close', false);
    },
    showNum(num) {
      return getBigNum(num, 2);
    },
    chooseCourse(course, index, idx) {
      this.optionCourse[index].productSkuList[idx].isSelect = !course.isSelect;
      let num = 0;
      this.optionCourse.forEach((item) => {
        item.productSkuList.forEach((child) => {
          // 同产品不同sku 互斥
          if (
            child.isSelect
            && child.productId === course.productId
            && child.productSkuId !== course.productSkuId
          ) {
            Object.assign(child, { isSelect: false });
          }
        });
        // 当前组超过可选数量置灰
        num = item.productSkuList.filter((child) => child.isSelect).length;
        Object.assign(item, { disbaled: item.groupInfo.selectProductNum === num });
      });
    },
    skuInfo(data) {
      const { selectSkuInfo } = data;
      this.mandatoryCourse.forEach((item) => {
        if (item.productId === data.productId) {
          Object.assign(item, {
            productSkuId: selectSkuInfo.skuId,
          });
        }
      });
    },

    initData() {
      const { packageProductRespList, packageId, packageGroupWebRespList } = this.courseBaseData;
      (packageProductRespList || []).forEach((item) => {
        Object.assign(item, { packageId });
      });
      this.mandatoryCourse = packageProductRespList || [];
      const courses = [];
      (packageGroupWebRespList || []).forEach((element) => {
        const {
          groupId, groupProductNum, name, selectProductNum,
        } = element;
        const productSkuList = [];
        const groupInfo = {};
        Object.assign(groupInfo, {
          groupId,
          groupProductNum,
          name,
          selectProductNum,
          num: 0,
        });
        element.packageProductWebRespList.forEach((course) => {
          const {
            isBuy, isExpire, isSoldOut, isOffline,
          } = course;
          if (!isBuy && !isExpire && !isSoldOut && !isOffline) {
            course.packageProductSkuWebRespList.forEach((child) => {
              const skuSpecJson = JSON.parse(child.skuSpecJson);
              productSkuList.push({
                packageGroupId: groupId,
                packageId: this.combinationId,
                name: course.productName,
                productId: course.productId,
                productSkuId: child.skuId,
                skuName: child.isDefault ? [] : skuSpecJson.map((item) => item.value),
                isSelect: false,
                disaled: !(
                  (child.isSetStock === 1 && child.availableStock)
                  || child.isSetStock === 0
                ),
              });
            });
          }
        });
        courses.push({ productSkuList, groupInfo });
      });
      this.optionCourse = courses;
    },
    // 加入购物车
    async addShopCar() {
      let flag = true;
      let groupCourse = [];
      this.optionCourse.forEach((item) => {
        const { productSkuList, groupInfo } = item;
        Object.assign(productSkuList, { groupId: groupInfo.groupId });
        const course = productSkuList.filter((list) => list.isSelect);
        groupCourse = [...groupCourse, ...course];
        if (course.length !== groupInfo.selectProductNum) {
          flag = false;
        }
      });
      if (flag) {
        const courseList = [...this.mandatoryCourse, ...groupCourse];
        const query = courseList.map((product) => ({
          productId: product.productId,
          skuId: product.productSkuId,
          groupId: product.packageGroupId,
          packageId: product.packageId,
          itemType: product.packageGroupId ? 2 : 1,
        }));
        const data = {
          cartPackageItemList: query,
          packageId: this.combinationId,
          type: 2, // 类型 1 产品 2 套餐
        };

        const res = await reqAddCart(data);
        if (res.code === 0) {
          this.$toast('已加入购物车');
          this.$emit('close', false);
          this.$parent.gioAddCart();
          this.$parent.getCartNum();
        } else {
          this.$toast(res.msg);
        }
      } else {
        this.$toast('请选择课程');
      }
    },

  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-popup {
  border-radius: 16px 16px 0 0;
  overflow-y: hidden;
}
.title {
  position: relative;
  width: 100%;
  height: 130px;
  padding: 40px 0 0 0;
  background: #f9f9f9;
  > p {
    color: #333;
    font-weight: 600;
    font-size: 36px;
    text-align: center;
  }
}
::v-deep .van-icon {
  position: absolute;
  top: 18px;
  right: 30px;
  font-size: 24px;
}
.content {
  height: 1050px;
  padding: 0 0 120px 0;
  overflow: hidden;
  .content-box {
    height: 100%;
    padding-bottom: 120px;
    overflow-y: auto;
  }
}
.mandatory {
  // height: 10000px;
  // border-bottom: 20px solid #f9f9f9;
  .mandatory-box {
    border-bottom: 20px solid #f9f9f9;
  }
}
.optional {
  padding: 40px;
  .group-name {
    // height: 100px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 32px;
    p {
      width: 100%;
      padding: 0 0 12px 0;
      color: #333;
      font-weight: 600;
      font-size: 32px;
      line-height: 44px;
    }
    span {
      color: #333;
      font-weight: 400;
      font-size: 28px;
      line-height: 40px;
    }
  }
  .optional-course {
    li {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-start;
      width: 678px;
      height: 105px;
      margin-bottom: 24px;
      padding: 20px;
      background: #fff;
      border: 2px solid #e8e8e8;
      border-radius: 4px;
      p {
        width: 100%;
        color: #333;
        font-weight: 600;
        font-size: 24px;
      }
      span {
        color: #787878;
        font-size: 24px;
      }
      img {
        display: none;
      }
    }
    li.disbaled {
      background: #f9f9f9;
      // opacity: 0.5;
      pointer-events: none;
      p,
      span {
        color: #c8c8c8;
      }
    }
    li.active {
      background: #fff5ed;
      border: 2px solid #ff6c02;
      border-radius: 4px;
      img {
        position: absolute;
        right: 0;
        bottom: -1px;
        display: block;
        width: 29px;
      }
      p,
      span {
        color: #ff6c02;
      }
    }
  }
}
.foot {
  position: fixed;
  bottom: 0;
  z-index: 200;
  width: 750px;
  height: 120px;
  padding: 20px 0 0 0;
  background: #fefffe;
  box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.05);
  > div {
    width: 678px;
    height: 82px;
    margin: 0 auto;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 82px;
    text-align: center;
    background: #ff6c02;
    border-radius: 41px;
  }
}
</style>
